module.exports = __webpack_public_path__ + "img/colored-circle-graph-icon-21022022.5a22af0c.svg";